// import { useState, useEffect } from "react";
// import css from "../admin/adm.module.css";
// import {
//   getStorage,
//   ref,
//   uploadBytesResumable,
//   getDownloadURL,
// } from "firebase/storage";
// import { v4 as uuidv4 } from "uuid";
// import { auth, db } from "../../firebase";
// import { getDocs } from "firebase/firestore";
// import {
//   doc,
//   setDoc,
//   addDoc,
//   collection,
//   serverTimestamp,
// } from "firebase/firestore";
// import Swal from "sweetalert2";

// export default function HeroAdm() {
//   const storage = getStorage();

//   const objList = [
//     {
//       name: "Ім'я",
//       transliter: "name",
//     },
//     {
//       name: "Опис 1",
//       transliter: "descOne",
//     },
//     {
//       name: "Опис 2",
//       transliter: "descSecond",
//     },
//     {
//       name: "Автор",
//       transliter: "autor",
//     },
//     {
//       name: "Книга",
//       transliter: "book",
//     },
//     {
//       name: "Малий опис",
//       transliter: "smallDesc",
//     },
//     {
//       name: "Опис в жовтому квадраті",
//       transliter: "greenKvadrat",
//     },
//     {
//       name: "Автор про героя",
//       transliter: "autorAboutHero",
//     },

//     {
//       name: "Історія створення",
//       transliter: "history",
//     },
//     {
//       name: "Інтервю 1",
//       transliter: "internOne",
//     },
//     {
//       name: "Інтервю 2",
//       transliter: "internSecond",
//     },
//     {
//       name: "Відео",
//       transliter: "video",
//     },
//     {
//       name: "Фото",
//       transliter: "foto",
//     },
//     {
//       name: "Вікова група",
//       transliter: "yearGroup",
//     },
//   ];

//   const [formData, setFormData] = useState({});
//   const [fotoFile, setFotoFile] = useState(null);

//   const handleInputChange = (e) => {
//     const { name, value, files } = e.target;
//     if (name === "foto" && files.length > 0) {
//       setFotoFile(files[0]);
//     } else {
//       setFormData((prevState) => ({ ...prevState, [name]: value }));
//     }
//   };

//   const handleFormSubmit = async (event) => {
//     event.preventDefault();

//     if (fotoFile) {
//       try {
//         const storageRef = ref(storage, `images/${fotoFile.name}`);
//         const uploadTask = uploadBytesResumable(storageRef, fotoFile);

//         Swal.fire({
//           title: "Uploading...",
//           html: "Please wait...",
//           allowOutsideClick: false,
//           didOpen: () => {
//             Swal.showLoading();
//           },
//         });

//         uploadTask.on(
//           "state_changed",
//           (snapshot) => {
//             const progress =
//               (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
//             Swal.getHtmlContainer().querySelector(
//               "b"
//             ).textContent = `${progress.toFixed(2)}%`;

//             console.log("progress1", progress);
//           },
//           (error) => {
//             console.log("error uploading file1", error);
//             Swal.fire({
//               title: "Error!",
//               text: "Failed to upload file.",
//               icon: "error",
//               confirmButtonText: "OK",
//             });
//           },
//           async () => {
//             const downloadURL = await getDownloadURL(storageRef);

//             const newObj = { ...formData, foto: downloadURL, uid: uuidv4() };

//             const frankDocRef = doc(db, "hero", newObj.uid);
//             await setDoc(frankDocRef, {
//               ...newObj,
//               created: serverTimestamp(),
//             });

//             console.log("Товар успішно додано до Firestore:", newObj);
//             Swal.fire({
//               title: "Success!",
//               text: "File uploaded successfully.",
//               icon: "success",
//               confirmButtonText: "OK",
//             });
//           }
//         );
//       } catch (error) {
//         console.log("Помилка під час додавання товару:", error);
//         Swal.fire({
//           title: "Error!",
//           text: "Failed to add product.",
//           icon: "error",
//           confirmButtonText: "OK",
//         });
//       }
//     } else {
//       console.log("Фото не вибрано");
//       Swal.fire({
//         title: "Error!",
//         text: "No photo selected.",
//         icon: "error",
//         confirmButtonText: "OK",
//       });
//     }
//   };

//   return (
//     <div className={css.WrapAdm}>
//       <form onSubmit={handleFormSubmit}>
//         {objList.map((el, index) => {
//           if (el.name === "Фото") {
//             return (
//               <div key={index} className={css.wrapSmallList}>
//                 <p className={css.paramBooks}>{el.name}</p>
//                 <input
//                   type="file"
//                   name={el.transliter}
//                   onChange={handleInputChange}
//                 />
//               </div>
//             );
//           } else {
//             return (
//               <div key={index} className={css.wrapSmallList}>
//                 <p className={css.paramBooks}>{el.name}</p>
//                 <input
//                   type="text"
//                   name={el.transliter}
//                   onChange={handleInputChange}
//                 />
//               </div>
//             );
//           }
//         })}
//         <button type="submit">Додати героя</button>
//       </form>
//     </div>
//   );
// }
import { useState, useEffect } from "react";
import css from "../admin/adm.module.css";
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { db } from "../../firebase";
import {
  doc,
  setDoc,
  collection,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";
import Swal from "sweetalert2";

export default function HeroAdm() {
  const storage = getStorage();

  const objList = [
    { name: "Ім'я", transliter: "name" },
    { name: "Опис 1", transliter: "descOne" },
    { name: "Опис 2", transliter: "descSecond" },
    { name: "Автор", transliter: "autor" },
    { name: "Книга", transliter: "book" },
    { name: "Малий опис", transliter: "smallDesc" },
    { name: "Опис в жовтому квадраті", transliter: "greenKvadrat" },
    { name: "Автор про героя", transliter: "autorAboutHero" },
    { name: "Історія створення", transliter: "history" },
    { name: "Інтервю 1", transliter: "internOne" },
    { name: "Інтервю 2", transliter: "internSecond" },
    { name: "Відео", transliter: "video" },
    { name: "Фото", transliter: "foto" },
  ];

  const [formData, setFormData] = useState({});
  const [fotoFile, setFotoFile] = useState(null);
  const [ageGroups, setAgeGroups] = useState([]); // Список вікових груп з бази
  const [selectedAges, setSelectedAges] = useState([""]); // Масив вибраних вікових груп

  useEffect(() => {
    const fetchAgeGroups = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "filters"));
        const filtersData = querySnapshot.docs.map((doc) => doc.data());

        const ageFilter = filtersData.find(
          (filter) => filter.transliter === "yearGroup"
        );

        if (ageFilter) {
          setAgeGroups(ageFilter.list);
        }
      } catch (error) {
        console.error("Помилка отримання вікових груп:", error);
      }
    };

    fetchAgeGroups();
  }, []);

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "foto" && files.length > 0) {
      setFotoFile(files[0]);
    } else {
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  const handleAgeChange = (index, event) => {
    const updatedAges = [...selectedAges];
    updatedAges[index] = event.target.value;
    setSelectedAges(updatedAges);
  };

  const addAgeGroup = () => {
    setSelectedAges([...selectedAges, ""]);
  };

  const removeAgeGroup = (index) => {
    const updatedAges = selectedAges.filter((_, i) => i !== index);
    setSelectedAges(updatedAges);
  };

  const handleFormSubmit = async (event) => {
    event.preventDefault();

    if (!fotoFile) {
      Swal.fire({
        title: "Error!",
        text: "No photo selected.",
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }

    try {
      const storageRef = ref(storage, `images/${fotoFile.name}`);
      const uploadTask = uploadBytesResumable(storageRef, fotoFile);

      Swal.fire({
        title: "Uploading...",
        html: "Please wait...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          Swal.getHtmlContainer().querySelector(
            "b"
          ).textContent = `${progress.toFixed(2)}%`;
        },
        (error) => {
          console.error("Помилка завантаження:", error);
          Swal.fire({
            title: "Error!",
            text: "Failed to upload file.",
            icon: "error",
            confirmButtonText: "OK",
          });
        },
        async () => {
          const downloadURL = await getDownloadURL(storageRef);

          const newObj = {
            ...formData,
            foto: downloadURL,
            uid: uuidv4(),
            yearGroup: selectedAges.filter((age) => age !== ""), // Видаляємо порожні значення
          };

          const docRef = doc(db, "hero", newObj.uid);
          await setDoc(docRef, {
            ...newObj,
            created: serverTimestamp(),
          });

          console.log("Герой успішно доданий:", newObj);
          Swal.fire({
            title: "Success!",
            text: "Hero added successfully.",
            icon: "success",
            confirmButtonText: "OK",
          });

          // Очищення форми після успішного додавання
          setFormData({});
          setFotoFile(null);
          setSelectedAges([""]);
        }
      );
    } catch (error) {
      console.error("Помилка при додаванні героя:", error);
      Swal.fire({
        title: "Error!",
        text: "Failed to add hero.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div className={css.WrapAdm}>
      <form onSubmit={handleFormSubmit}>
        {objList.map((el, index) => (
          <div key={index} className={css.wrapSmallList}>
            <p className={css.paramBooks}>{el.name}</p>
            {el.name === "Фото" ? (
              <input
                type="file"
                name={el.transliter}
                onChange={handleInputChange}
              />
            ) : (
              <input
                type="text"
                name={el.transliter}
                value={formData[el.transliter] || ""}
                onChange={handleInputChange}
              />
            )}
          </div>
        ))}

        {/* Поле вибору вікових груп */}
        <div className={css.wrapSmallList}>
          <p className={css.paramBooks}>Вікові групи</p>
          {selectedAges.map((age, index) => (
            <div key={index} className={css.ageGroupWrapper}>
              <select
                className={css.customSelect}
                value={age}
                onChange={(event) => handleAgeChange(index, event)}
              >
                <option value="" disabled>
                  Оберіть вікову групу
                </option>
                {ageGroups.map((group, idx) => (
                  <option key={idx} value={group}>
                    {group}
                  </option>
                ))}
              </select>
              {index > 0 && (
                <button
                  type="button"
                  className={css.removeAgeButton}
                  onClick={() => removeAgeGroup(index)}
                >
                  Видалити
                </button>
              )}
            </div>
          ))}
          <button
            type="button"
            className={css.addAgeButton}
            onClick={addAgeGroup}
          >
            Додати ще вікову групу
          </button>
        </div>

        <button type="submit">Додати героя</button>
      </form>
    </div>
  );
}
